import {
  Entity,
  PrimaryGeneratedColumn,
  ManyToOne,
  OneToMany,
  JoinColumn,
  Column
} from "typeorm";
import { LicenseType, LicenseTypeAnswer } from ".";

@Entity()
export class LicenseTypeQuestion {
  @PrimaryGeneratedColumn() id: number;

  @Column("int") licenseTypeId: number;

  @ManyToOne(() => LicenseType)
  @JoinColumn()
  licenseType: LicenseType;

  @OneToMany(
    () => LicenseTypeAnswer,
    licenseTypeAnswer => licenseTypeAnswer.licenseTypeQuestion
  )
  licenseTypeAnswers: LicenseTypeAnswer[];

  @Column("varchar") question: string;

  @Column("varchar") questionName: string;

  @Column("tinyint") autoPopulated: boolean;

  @Column("tinyint", { default: false })
  triggersReview: boolean;

  @Column("varchar", { nullable: true })
  triggersReviewAnswer: string;

  @Column("varchar") required: string;

  @Column("varchar", { nullable: true })
  requiredDependencies: string;

  @Column("varchar") answerType: string;

  @Column("varchar", { nullable: true })
  hiddenUnless: string;

  @Column("varchar", { nullable: true })
  answerOptions: string;

  @Column("tinyint", { default: false })
  internal: boolean;

  @Column("varchar", { nullable: true })
  calculation: string;

  @Column("int") ordering: number;
}
